import React, { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

interface CustomEditModalProps {
  isVisible: boolean;
  onPressConfirm: () => void;
  onPressCancel: () => void;
  children: ReactNode;
}

const CustomEditModal: React.FC<CustomEditModalProps> = ({
  isVisible,
  onPressConfirm,
  onPressCancel,
  children,
}) => {
  return (
    <Dialog
      open={isVisible}
      onClose={onPressCancel}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      PaperProps={{
        style: {
          padding: "20px",
          borderRadius: 10,
          width: 900,
          height: "auto",
        },
      }}
    >
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          <Button
            variant="contained"
            sx={{ bgcolor: "primary.light", borderRadius: 1, mr: 2 }}
            onClick={onPressConfirm}
          >
            Guardar
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "secondaryAccent.dark", borderRadius: 1 }}
            onClick={onPressCancel}
          >
            Cancelar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CustomEditModal;
